import React, { useState } from "react";
import "./index.scss";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 500) {
      setVisible(true);
    } else if (scrolled <= 500) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <span
      className="material-icons scroll-top-button"
      style={{ display: visible ? "inline" : "none" }}
      onClick={scrollToTop}
    >
      arrow_upward
    </span>
  );
};

export default ScrollButton;
